export default {
  name: 'productTags',
  component({ tagConfig = '', configuredTags = '', maxTags = 3, initialTags = [] } = {}) {
    return {
      tagConfig,
      configuredTags,
      maxTags,
      tags: initialTags,

      init() {
        const tile = this.$el.closest('[x-product-tile-init]');
        if (tile) {
          tile.addEventListener('tile:swap-product', (e) => {
            this.tags = e.detail?.tags || [];
          });
        }
      },

      get displayTags() {
        const productTags = this.tags;
        const configured = this.configuredTags ? this.configuredTags.split(',').map(t => t.trim()).filter(Boolean) : [];
        // Build name → display map from tagConfig (format: "name:::display|name:::display" or "name:::display,color|name:::display,color")
        const configMap = {};
        if (this.tagConfig) {
          this.tagConfig.split('|').forEach(pair => {
            const separatorIndex = pair.indexOf(':::');
            if (separatorIndex === -1) return;
            const name = pair.slice(0, separatorIndex).trim();
            const displayAndColor = pair.slice(separatorIndex + 3).trim();
            
            if (displayAndColor.includes(',')) {
              const parts = displayAndColor.split(',');
              const display = parts[0].trim();
              const color = parts[1].trim();
              configMap[name] = { display, color };
            } else {
              configMap[name] = { display: displayAndColor, color: null };
            }
          });
        }

        const result = configured
          .filter(name => {
            const hasTag = productTags.includes(name);
            return hasTag;
          })
          .slice(0, this.maxTags)
          .map(name => {
            const config = configMap[name];
            if (config) {
              return { 
                name, 
                display: config.display, 
                color: config.color 
              };
            }
            return { name, display: name, color: null };
          });
        return result;
      }
    };
  }
};
